import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import typeTransaction from "../manage/typeTransaction";
import helpersNumbers from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import TitleBar from "../../../partials/content/TitleBar";

export default function AddTransactionCoworker() {
  const [amount, setAmount] = useState(250000);
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState();
  const history = useHistory();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getCustomerUser();
  }, []);

  const getCustomerUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let users = await sendRequestGetCustomerUser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    users = users.map((user) => {
      return {
        id: user.id,
        first_name: user.first_name,
        last_name: user.last_name != undefined ? user.last_name : "",
        charge: user.charge,
      };
    });
    setUsers(users);
  };

  const sendRequestGetCustomerUser = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/coworker/user",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const generateOptionTagUsers = (users) => {
    return users.map((user) => {
      return (
        <option value={user.id}>
          {`
          شماره کاربر : ${helpersNumbers.toPersianNum(user.id)}
          |
           ${user.first_name} ${user.last_name}
          |  موجودی کاربر : 
          ${helpersNumbers.toPersianNum(
            helpersNumbers.toFormatFinanceNumber(user.charge)
          )} تومان`}
        </option>
      );
    });
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }

    changeAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const changeAmount = (number) => {
    setAmount(number);
  };

  const scrollForSeeMessage = () => {
    const element = document.getElementById("add-transaction");
    element.scrollIntoView();
  };

  const sendForm = async (e) => {
    e.preventDefault();

    const dataForm = getDataFrom();
    if (!dataForm) {
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddTransaction = await sendRequestAddTransaction(
      dataForm
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddTransaction) {
      return;
    }

    history.push("/finance/coworker/transaction");
  };

  const getDataFrom = () => {
    if (amount <= 0) {
      setMessage({
        type_class: "alert alert-danger ",
        text: "مبلغ نامعتبر است.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    const userID = document.querySelector("#user").value;
    if (userID == 0) {
      setMessage({
        type_class: "alert alert-danger ",
        text: "لطفا کاربر را انتخاب کنید.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    const operate = document.querySelector("#operate").value;
    if (operate == 0) {
      setMessage({
        type_class: "alert alert-danger ",
        text: "لطفا عملیات را انتخاب کنید.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    let operateString = Object.keys(
      typeTransaction.typeOperateTransaction
    ).find(
      (key) => typeTransaction.typeOperateTransaction[key] === parseInt(operate)
    );
    operateString = operateString.toLowerCase();

    const reason = document.querySelector("#reason").value;
    if (!reason) {
      setMessage({
        type_class: "alert alert-danger ",
        text: "لطفا دلیل انجام این تراکنش را بنویسید.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return {
      amount: amount,
      coworker_customer_ID: parseInt(userID),
      operate: operateString,
      reason: reason,
    };
  };

  const sendRequestAddTransaction = async (dataForm) => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/payment/transaction/coworker-customer",
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="تراکنش جدید" />

        <section className="content pt-5">
          <div className="card" id="add-transaction">
            <div className="card-body">
              <div className="container">
                <div className="text-left">
                  <Link
                    className="btn btn-primary"
                    to="/finance/coworker/transaction"
                  >
                    بازگشت
                    <span className="pr-2">
                      <i class="fas fa-arrow-left"></i>
                    </span>
                  </Link>
                </div>
                <div className="row justify-content-center">
                  <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                    {messageTag}
                    <form onSubmit={sendForm}>
                      <div class="form-group">
                        <label>مبلغ (تومان)</label>
                        <input
                          type="text"
                          id="amount"
                          class="form-control number-finance"
                          value={helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(amount)
                          )}
                          onChange={inputAmountChangeHandler}
                          onBeforeInput={inputAmountBeforeInputHandler}
                          dir="ltr"
                        />
                      </div>
                      <div class="form-group">
                        <label>کاربر</label>
                        <select class="form-control" id="user">
                          <option value={0}>انتخاب کنید</option>
                          {generateOptionTagUsers(users)}
                        </select>
                      </div>
                      <div class="form-group">
                        <label>نوع تراکنش</label>
                        <select class="form-control" id="operate">
                          <option value={0}>انتخاب کنید</option>
                          {Object.keys(
                            typeTransaction.typeOperateTransaction
                          ).map(function (key, index) {
                            return (
                              <option
                                value={
                                  typeTransaction.typeOperateTransaction[key]
                                }
                              >
                                {
                                  typeTransaction.typeOperateTransactionString()[
                                    typeTransaction.typeOperateTransaction[key]
                                  ]
                                }
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div class="form-group">
                        <label>دلیل خود را از این تراکنش بنویسید </label>
                        <div>
                          <textarea
                            className="form-control"
                            id="reason"
                            rows="5"
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group">
                        <button className="btn btn-success">اعمال</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
